export const MODAL_WRAPPER_GROUP_STYLES = "flex flex-col gap-4 px-4";
export const MODAL_ROW_GROUP_STYLES =
  "rounded-xl border border-stone-200 dark:border-stone-700";

export const MODAL_ROW_STYLES =
  "items-center justify-between px-4 py-2 gap-y-2";

export const GRID_MODAL_ROW_STYLES = `grid grid-cols-1 xs:grid-cols-2 ${MODAL_ROW_STYLES}`;

export const COLLAPSED_WRAPPER_STYLES =
  "w-full rounded-b-xl border-t border-stone-100 bg-stone-50 text-left dark:border-none dark:bg-stone-900 [&>*:not(:first-child)]:border-t [&>*:not(:first-child)]:border-stone-100 dark:[&>*:not(:first-child)]:border-stone-800";
